import {apiConstants, config, requestOptions, requestTypes, sendRequest} from "../Utilities/Api";

class serverBraillerRepairApi {
static requestRepair(repairRequest: Record<string, unknown>) {
    return sendRequest(
        requestOptions(config.URL + `braillers/repair/request`,
            requestTypes.POST,
            JSON.stringify(repairRequest),
            apiConstants.successMessage.brailler.REPAIR_REQUESTED,
        ),
    );
}

static approveRepair(repairId: string, approvalData: Record<string, unknown>) {
    return sendRequest(
        requestOptions(config.URL + `braillers/repair/${repairId}/approve`,
            requestTypes.PUT,
            JSON.stringify(approvalData),
            apiConstants.successMessage.brailler.REPAIR_APPROVED,
        ),
    );
}

static denyRepair(repairId: string, denyData: Record<string, unknown>) {
    return sendRequest(
        requestOptions(config.URL + `braillers/repair/${repairId}/deny`,
            requestTypes.PUT,
            JSON.stringify(denyData),
            apiConstants.errorMessage.brailler.REPAIR_DENIED,
        ),
    );
}

static getRepairsByLoan(loanId: string) {
    return sendRequest(
        requestOptions(config.URL + `braillers/repair/loan/${loanId}`,
            requestTypes.GET,
        ),
    );
}

static getRepairById(repairId: string) {
    return sendRequest(
        requestOptions(config.URL + `braillers/repair/${repairId}`,
            requestTypes.GET,
        ),
    );
}

static updateRepairs(loanItems: Record<string, unknown>[]) {
    return sendRequest(
        requestOptions(config.URL + `braillers/repair/`,
            requestTypes.PUT,
            JSON.stringify(loanItems),
        ),
    );
}

static getAvailableReplacementInventory(repairId: string) {
    return sendRequest(
        requestOptions(config.URL + `braillers/repair/${repairId}/replacement-inventory`,
            requestTypes.GET,
        ),
    );
}

static createReplacementLoan(repairId: string, serialNumber: string | null = null, catalogItemId: string | null = null, shelfLocation: string | null = null) {
        const body = JSON.stringify({ 
            serialNumber, 
            catalogItemId, 
            shelfLocation 
        });
        return sendRequest(
            requestOptions(config.URL + `braillers/repair/${repairId}/replacement-loan`,
                requestTypes.POST,
                body,
                "Replacement brailler loan created successfully",
            ),
        );
    }
}

export const braillerRepairApi = config.environment.MODE === config.modes.SERVER ? serverBraillerRepairApi : serverBraillerRepairApi;